export const environment = {
  production: false,
  // Host for the fixed-content videos and their .vtt caption tracks.
  // Captions used to be hardcoded in learn-more.component.ts, which meant
  // Production served them from the dev container.
  fixedContentBaseUrl: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/',
  homeVideoURL: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/one_morning_-_moments_of_realization.mp4?sp=r&st=2026-03-27T18:27:15Z&se=2096-03-28T02:42:15Z&spr=https&sv=2024-11-04&sr=c&sig=ocNU%2F0HAKZ1zlMwVd4zjXFsGl4jn84WhT8hgMBK0%2Fh4%3D',
  learnMoreVideoURL: 'https://radian01.blob.core.windows.net/onemorningdev/fixedcontent/one_morning_-_what\'s_an_eap.mp4?sp=r&st=2026-03-27T18:27:15Z&se=2096-03-28T02:42:15Z&spr=https&sv=2024-11-04&sr=c&sig=ocNU%2F0HAKZ1zlMwVd4zjXFsGl4jn84WhT8hgMBK0%2Fh4%3D'
};

